import { render, staticRenderFns } from "./VideoCandidate.vue?vue&type=template&id=4a41e7ce&"
import script from "./VideoCandidate.vue?vue&type=script&lang=js&"
export * from "./VideoCandidate.vue?vue&type=script&lang=js&"
import style0 from "./VideoCandidate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports